'use client';

import Breadcrumb from '@/components/Breadcrumb';
import HeaderNavigator from '@/components/Navigator';
import React from 'react';
import routes from '@/app/routes';
import ProductionConsumptionListWrapper from './wrapper';
import { ProductionAndConsumptionFilterProvider } from '../context';

const ProductionAndConsumptionMaterialListPage: React.FC = () => {
  return (
    <>
      <HeaderNavigator title="Select production & consumption item" />
      <Breadcrumb
        items={[
          {
            label: 'Matchmaker',
            path: routes.MATCH_MAKER,
          },
          {
            label: 'Select produced material',
            path: routes.MATCH_MAKER_OUTPUT_MATERIALS,
          },
          {
            label: 'Select production & consumption item',
          },
        ]}
        className="w-full fixed top-[112px]"
      />
      <div className="px-6 py-6 md:px-14">
        <ProductionAndConsumptionFilterProvider>
          <ProductionConsumptionListWrapper />
        </ProductionAndConsumptionFilterProvider>
      </div>
    </>
  );
};

export default ProductionAndConsumptionMaterialListPage;
